import WDHImageSpot from '../../../../wdh-feature/wdh-image-spot/src/js/wdh-image-spot';
var imageSpot = new WDHImageSpot();
imageSpot.useEqualImageHeight = true;
imageSpot.useEqualHeaderHeight = true;
imageSpot.useEqualBodyHeight = true;
imageSpot.makeImageSpotClickable = true;
imageSpot.run();